import { Button, Modal, } from 'antd';
import React from 'react'
import { format } from '../../App';
import moment from 'moment';
import { pad } from '../../data/allfunction';
const ShowModalPolicy = (props) => {
    // console.log(props)
    try {
        let { no, modal_show_alldetail, setmodal_show_alldetail, getOneFull } = props
        return (
            <Modal
                width={500}
                title={"ລາຍລະອຽດຂອງສັນຍາເລກທີ " + pad(no)}
                visible={modal_show_alldetail}
                onOk={() => setmodal_show_alldetail(false)}
                onCancel={() => setmodal_show_alldetail(false)}
                footer={[
                    <Button key="back" onClick={() => setmodal_show_alldetail(false)}>
                        ກັບຄືນ
                    </Button>

                ]}
            >
                <div className="row modalBox">
                    <div className="col">ຊື່ລູກຄ້າ</div>
                    <div className="col">{getOneFull.o_name}</div>
                </div>
                <div className="row modalBox">
                    <div className="col">ເບີໂທ</div>
                    <div className="col">{getOneFull.o_tel}</div>
                </div>
                <div className="row modalBox">
                    <div className="col">ເລກປ້າຍ</div>
                    <div className="col">{getOneFull.o_plate}</div>
                </div>
                <div className="row modalBox">
                    <div className="col">ເລກຈັກ</div>
                    <div className="col">{getOneFull.o_engine}</div>
                </div>
                <div className="row modalBox">
                    <div className="col">ເລກຖັງ</div>
                    <div className="col">{getOneFull.o_chassis}</div>
                </div>
                <div className="row modalBox">
                    <div className="col">ປະເພດລົດ</div>
                    <div className="col">{getOneFull.o_type}</div>
                </div>
                <div className="row modalBox">
                    <div className="col">ປະເພດການຄຸ້ມກັນ</div>
                    <div className="col">{getOneFull.cover}</div>
                </div>
                <div className="row modalBox">
                    <div className="col">ວັນທີເລີ່ມຄຸ້ມກັນ</div>
                    <div className="col">{moment(getOneFull.start).format('DD-MM-YYYY HH:mm:ss')}</div>
                </div>
                <div className="row modalBox">
                    <div className="col">ວັນທີສິນສຸດການຄຸ້ມກັນ</div>
                    <div className="col">{moment(getOneFull.end).format('DD-MM-YYYY HH:mm:ss')}</div>
                </div>
                <div className="row modalBox">
                    <div className="col">ຄ່າທຳນຽມທັງໝົ້ດ</div>
                    <div className="col">{format(getOneFull.total_premuim)}</div>
                </div>
                <div className="row modalBox">
                    <div className="col">ຄ່າທຳນຽມກ່ອນອາກອນ</div>
                    <div className="col">{format(getOneFull.premuim)}</div>
                </div>
                <div className="row modalBox">
                    <div className="col">{getOneFull.paid === 1 ?
                        "ເປີເຊັນການຂາຍ  " + getOneFull.commission_percen
                        :
                        "ເປີເຊັນການຂາຍ (ຄ່າຄອມ-ຈ່າຍຊ້າ) (" + format(getOneFull.Total_MVL) + "-" + getOneFull.paylate + ")"
                    }%</div>
                    <div className="col">{format(getOneFull.agentCommit)}</div>
                </div>
                <div className="row modalBox">
                    <div className="col">
                        ເງິນຝາກຄັງ
                    </div>
                    <div className="col">{format(getOneFull.Diposit)}% = {format(getOneFull.depos)}</div>
                </div>
                <div className="row modalBox">
                    <div className="col">{
                        "ຫັກອາກອນ"
                        + getOneFull.Text116
                        + "%"
                    } </div>
                    <div className="col">{format(getOneFull.tex)}</div>
                </div>
                <div className="row modalBox">
                    <div className="col">ລາຍຮັບເຂົ້າ ZJI</div>
                    <div className="col">{format(getOneFull.ZJIIncom)}</div>
                </div>
                <div className="row modalBox">
                    <div className="col">ລູກຄ້າຈາກຕົວແທນ</div>
                    <div className="col">{getOneFull.name}</div>
                </div>
                <div className="row modalBox">
                    <div className="col">ເຂົ້າສູ່ລະບົບວັນທີ</div>
                    <div className="col">{moment(getOneFull.dateadd).format('DD-MM-YYYY HH:mm:ss')}</div>
                </div>
                <div className="row modalBox">
                    <div className="col">ສະຖານະລູກຄ້າຊຳລະ</div>
                    <div className={getOneFull.emp_paid === 0 ? "col textRed" : "col"} >
                        {getOneFull.emp_paid === 0 ? 'ລໍຖ້າການຊຳລະ' : 'ການຊຳລະສົມບູນ'}
                    </div>
                </div>
                <div className="row modalBox">
                    <div className="col">ສະຖານະຕົວແທນຊຳລະ</div>
                    <div className={getOneFull.paid === 0 ? "col textRed" : "col"} >
                        {getOneFull.paid === 0 ?
                            'ລໍຖ້າການຊຳລະ'
                            :
                            'ການຊຳລະສົມບູນ ວັນທີ ' + moment(getOneFull.paid_date).format('DD-MM-YYYY HH:mm:ss')
                        }

                    </div>
                </div>
                <div className="row modalBox">
                    <div className="col">ສະຖານະການຍົກເລີກສັນຍາ</div>
                    <div className={getOneFull.cancel === 0 ? "col" : "col textRed"} >
                        {getOneFull.cancel === 0 ?
                            'ບໍ່ຖືກຍົກເລີກ'
                            :
                            'ຖືກຍົກ ວັນທີ ' + moment(getOneFull.cancel_date).format('DD-MM-YYYY HH:mm:ss')
                        }

                    </div>
                </div>
                <div className="row modalBox">
                    <div className="col">
                        ນະໂຍບາຍຈ່າຍຊ້າ
                    </div>
                    <div className={getOneFull.enable_pay_late === 0 ? "col" : "col textRed"} >
                        {getOneFull.enable_pay_late === 0 ?
                            'ບໍ່ອະນຸຍາດ'
                            :
                            'ອະນຸຍາດ'
                        }

                    </div>
                </div>
                <div className="row modalBox">
                    <div className="col">ໝາຍເຫດ</div>
                    <div className="col">
                        {getOneFull.detial}

                    </div>
                </div>


            </Modal>
        );
    } catch (error) {
        // console.log(error)
    }
}

export default ShowModalPolicy;
